import { render, staticRenderFns } from "./TrendList.vue?vue&type=template&id=7d288f1c&scoped=true"
import script from "./TrendList.vue?vue&type=script&lang=js"
export * from "./TrendList.vue?vue&type=script&lang=js"
import style0 from "./TrendList.vue?vue&type=style&index=0&id=7d288f1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d288f1c",
  null
  
)

export default component.exports